import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { ArrowRight, CheckCircle } from "lucide-react";
export default function StreamlineYourOperations() {
  const benefits = ["Identify workflow bottlenecks and inefficiencies", "Receive actionable improvement recommendations", "Streamline operations for increased productivity", "Optimize vendor relationships and systems"];
  return <section className="bg-background py-16">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-3xl">
          <Card className="border-border shadow-soft transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1 hover:shadow-medium">
            <CardHeader>
              <CardTitle className="text-2xl text-foreground">
                Streamline Your Operations
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-6">
              <p className="text-foreground/80 leading-relaxed">
                Aran Group's Operational Efficiency Audits provide a comprehensive review of your existing workflows, systems, and vendor relationships. We identify bottlenecks and propose actionable improvements to help your business operate more efficiently and cost-effectively.
              </p>
              
              <div className="space-y-3">
                {benefits.map((benefit, i) => <div key={i} data-index={i} className="flex items-start gap-3 animate-fade-in-up" style={{
                animationDelay: `${i * 100}ms`
              }}>
                    <CheckCircle className="size-5 shrink-0 text-accent mt-0.5" />
                    <span className="text-foreground/70 text-sm">{benefit}</span>
                  </div>)}
              </div>

              <div className="pt-4">
                <Link to="/OperationalEfficiencyAuditsPage">
                  <Button className="group">
                    Learn More About Our Audits
                    <ArrowRight className="size-4 transition-transform group-hover:translate-x-1" />
                  </Button>
                </Link>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}